import styles from './style.module.scss';

const ServerError = () => {
  return <div className={styles.root}>Sorry! Server not working.</div>;
};
export default ServerError;
